import { render, staticRenderFns } from "./ArticleOverview.vue?vue&type=template&id=01d5018c"
import script from "./ArticleOverview.vue?vue&type=script&lang=js"
export * from "./ArticleOverview.vue?vue&type=script&lang=js"
import style0 from "./ArticleOverview.vue?vue&type=style&index=0&id=01d5018c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports